const NewError = ({ message }) => {
    const string = typeof message === 'string' ? message : 'Error'
    return (
        <div className="flex flex-col items-center">
            <h3>Qualcosa è andato storto. Ricarica la pagina e riprova</h3>
            {<h5>{message}</h5>}
        </div>
    )
}

export default NewError;